<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 sync-header">
      Form 1118 Sync Process
    </div>
  </div>
  <div class="row sync-content">
    <div class="col-md-2">
      <div class="row">
        <div class="col-md-5 lab-text">
          Tax Year
        </div>
        <div class="col-md-7">
          <select id="FTC_SSSYNC_UD_1" class="form-control" [(ngModel)]="selectedTaxYear" (ngModelChange)="getScenarioDropDown()" style="height: 30px;">
            @for (taxyr of filteredTaxYearData; track $index) {
<option 
                    [value]="taxyr.CODE_DISP_DESC"
                    [selected]="taxyr.CODE_KEY === TaxYearKey">
              {{taxyr.CODE_DISP_DESC}}
            </option>
}
          </select>
        </div>
      </div>
    </div>
    
    <div class="col-md-2">
      <div class="row">
        <div class="col-md-4 lab-text">
          Scenario
        </div>
        <div class="col-md-8">
          <select id="FTC_IAPR_CD_12" class="form-control" [(ngModel)]="selectedScenario" (ngModelChange)="getFilingGroupDropDown()" style="height: 30px;">
            @for (option of scenarioDropDown; track $index) {
<option [value]="option.VALUE">
              {{option.LABEL}}
            </option>
}
          </select>
        </div>
      </div>
    </div>
    
    <div class="col-md-1 lab-text">
      Filing Group
    </div>
    <div class="col-md-2">
      <select id="FTC_IAPR_CD_12" class="form-control" [(ngModel)]="selectedFilingGroup" (ngModelChange)="filingEnityDetailInfo()" style="height: 30px;">
        @for (option of filingGroupDropDown; track $index) {
<option [value]="option.VALUE">
          {{option.LABEL}}
        </option>
}
      </select>
    </div>

    <div class="col-md-1 lab-text">
      Filer Entity
    </div>
    <div class="col-md-2">
      <select id="FTC_IAPR_CD_12" class="form-control" [(ngModel)]="filerEntity" (ngModelChange)="showSyncButton()" style="height: 30px;">
        @for (option of filingEnityDetails; track $index) {
<option [value]="option.FILER_LE_KEY">
          {{option.FILER_LE}}
        </option>
}
      </select> 
    </div>
    <div class="col-md-2 sync-button-col">
      @if (showFilerEntity) {
<button id="FTC_SSSYNC_UD_8" class="btn btn-info btn-sm" type="button" style="height: 30px; white-space: nowrap;" 
             
              (click)="sync1118Process()">
        Form 1118 Sync
      </button>
}
    </div>
  </div>
</div>

@if (showConfirmDialog) {
<div class="confirmation-modal-overlay">
  <gtw-confirmation-modal
    [config]="modalConfig"
    [visible]="false"
    (confirmed)="onConfirmSync()"
    (cancelled)="onCancelConfirm()"
    (closed)="onCancelConfirm()">
  </gtw-confirmation-modal>
</div>
}

